import { Activity, FileText, FolderKanban, KeyRound, LogOut, MonitorCog, ScrollText, Upload, UserCog, Users } from 'lucide-react';
import { useState } from 'react';
import { NavLink, Outlet } from 'react-router';
import { useAuth, useMe, usePermissions } from '../auth';
import { ROLE_LABEL } from '../format';
import { useConnection } from '../realtime';
import { ChangePasswordModal } from '../pages/ChangePassword';

export function BrandMark() {
  return (
    <span className="brand-mark">
      <FileText size={18} />
    </span>
  );
}

export function LiveIndicator() {
  const state = useConnection();
  const label = { open: 'En directo', connecting: 'Conectando…', paused: 'En pausa', closed: 'Sin conexión' }[state];
  return (
    <span className="live" title="Actualización en tiempo real">
      <span className={`live-dot ${state}`} />
      {label}
    </span>
  );
}

export function Layout() {
  const { user, group } = useMe();
  const { logout } = useAuth();
  const perms = usePermissions();
  const [changingPassword, setChangingPassword] = useState(false);

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <BrandMark />
          <div>
            OCR 1SK
            <small>PDF con texto seleccionable</small>
          </div>
        </div>

        <nav className="nav">
          <NavLink to="/jobs">
            <FolderKanban size={17} /> Trabajos
          </NavLink>
          {perms.canUpload && (
            <NavLink to="/upload">
              <Upload size={17} /> Enviar documentos
            </NavLink>
          )}

          {perms.isAdmin && <div className="nav-section">Administración</div>}
          {perms.isSuper && (
            <NavLink to="/groups">
              <Users size={17} /> Grupos
            </NavLink>
          )}
          {perms.isAdmin && (
            <>
              <NavLink to="/users">
                <UserCog size={17} /> Usuarios
              </NavLink>
              <NavLink to="/api-keys">
                <KeyRound size={17} /> API keys
              </NavLink>
              <NavLink to="/agents">
                <MonitorCog size={17} /> Agentes
              </NavLink>
              <NavLink to="/usage">
                <Activity size={17} /> Consumo
              </NavLink>
              <NavLink to="/audit">
                <ScrollText size={17} /> Auditoría
              </NavLink>
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="who" title={user.email}>
            {user.name}
          </div>
          <div className="meta">
            {ROLE_LABEL[user.role]}
            {group ? ` · ${group.name}` : ''}
          </div>
          <div className="actions">
            <button onClick={() => setChangingPassword(true)}>Contraseña</button>
            <button onClick={() => void logout()}>
              <LogOut size={14} /> Salir
            </button>
          </div>
        </div>
      </aside>

      <main className="main">
        <Outlet />
      </main>

      {changingPassword && <ChangePasswordModal onClose={() => setChangingPassword(false)} />}
    </div>
  );
}
